const Emoji_B = {
    ':badair': { id: 106, width: 48, height: 19 },
    ':bag': { id: 107, width: 22, height: 23 },
    ':balloon': { id: 108, width: 18, height: 32 },
    ':bash': { id: 109, width: 41, height: 28 },
    ':basketball': { id: 110, width: 31, height: 20 },
    ':batman': { id: 111, width: 20, height: 27 },
    ':bb': { id: 112, width: 32, height: 20 },
    ':beaver': { id: 41, width: 18, height: 18 },
    ':bee': { id: 113, width: 40, height: 33 },
    ':beer': { id: 52, width: 18, height: 18 },
    ':biggrin': { id: 115, width: 20, height: 20 },
    ':biggrin2': { id: 114, width: 20, height: 20 },
    ':biggrinthumb': { id: 116, width: 40, height: 20 },
    ':bigsmile': { id: 117, width: 20, height: 20 },
    ':bird': { id: 59, width: 18, height: 18 },
    ':bleh': { id: 118, width: 18, height: 18 },
    ':blink': { id: 31, width: 20, height: 20 },
    ':blink2': { id: 119, width: 20, height: 20 },
    ':blue_bandana': { id: 120, width: 23, height: 19 },
    ':blush-anim-cl': { id: 122, width: 20, height: 20 },
    ':blush': { id: 123, width: 18, height: 18 },
    ':blush2': { id: 121, width: 20, height: 20 },
    ':blushing': { id: 125, width: 18, height: 18 },
    ':blushing2': { id: 124, width: 18, height: 18 },
    ':boat': { id: 126, width: 26, height: 33 },
    ':bomb': { id: 127, width: 23, height: 18 },
    ':book': { id: 128, width: 35, height: 20 },
    ':bored': { id: 130, width: 15, height: 15 },
    ':bored2': { id: 129, width: 20, height: 20 },
    ':borg': { id: 131, width: 18, height: 18 },
    ':bot': { id: 132, width: 18, height: 18 },
    ':bouti': { id: 608, width: 18, height: 18 },
    ':boxed': { id: 134, width: 18, height: 18 },
    ':boxed2': { id: 133, width: 18, height: 18 },
    ':brokeheart': { id: 63, width: 18, height: 18 },
    ':buhbye': { id: 606, width: 28, height: 18 },
    ':busted_blue': { id: 136, width: 18, height: 24 },
    ':busted_cop': { id: 137, width: 20, height: 28 },
    ':busted_red': { id: 138, width: 18, height: 24 },
    ':bye': { id: 142, width: 15, height: 15 },
    ':bye2': { id: 140, width: 20, height: 20 },
}

export default Emoji_B
